$(document).ready(function () {
    if($("#password-section").length){
        var passwordSection = $("#password-section");
        var productContent = $("[after-password]");
        var errorMessage = $("#error-message");
        var submitButton = $("#submit-password");
        let data_campaign = $("#password-check").data("campaign");
    
        function setCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + (value || "") + expires + "; path=/";
        }
    
        function getCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }
    
        function deleteCookie(name) {
            document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    
        // "pass_" + data_campaign
        var savedPassword = getCookie("pass_campaign");
        $.ajax({
            url: "https://career-ct.shopify-plugin.devbdd.com/check-password",
            type: "POST",
            data: { password: savedPassword, campaign: data_campaign },
            dataType: "json",
            success: function(result) {
                if(result.status == 200){
                    productContent.show().css("opacity", "1");
                    passwordSection.remove();
                }
                else {
                    passwordSection.show();
                    productContent.remove();
                }
            },
            error: function(xhr, status, error) {
                console.log("Terjadi kesalahan:", error);
            }
        });

        // deleteCookie("pass_campaign");
    
        $("#password-check").on("submit", function(e) {
            e.preventDefault();
            errorMessage.hide();
            $("#submit-password").html("Please wait..").attr("disabled", "disabled")
    
            var userInput = $("#password-input").val();
            $.ajax({
                url: "https://career-ct.shopify-plugin.devbdd.com/check-password",
                type: "POST",
                data: { password: userInput, campaign: data_campaign },
                dataType: "json",
                success: function(result) {
                    setTimeout(() => {
                        $("#submit-password").html("Submit").attr("disabled", false)
                        if(result.status == 200){
                            setCookie("pass_campaign", userInput, 1);
                            location.reload();
                        }
                        else {
                            errorMessage.show();
                        }
                    }, 500);
                },
                error: function(xhr, status, error) {
                    console.log("Terjadi kesalahan:", error);
                }
            });
        });
    }
});